import React from 'react';
import {
  Link,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  Typography,
} from '@mui/material';
import { getZoneOffsettedDate } from '../../../../utils/dates';
import formattedMessages from '../../../../messages/account/CompanyProfileMessages';

const CampaignsTable = ({ campaigns, onClickCampaign }) => {
  const generateCampaignTable = () => {
    console.log('date', typeof campaigns[0].expiration_date);
    return (
      <TableBody>
        {campaigns.map((campaign) => {
          const rezonedDate = campaign.expiration_date
            ? getZoneOffsettedDate(campaign.expiration_date)
            : 'N/A';
          return (
            <TableRow key={campaign.campaign_code}>
              <TableCell>
                <Link
                  tabIndex={1}
                  onClick={() => onClickCampaign(campaign.campaign_code)}
                >
                  {campaign.campaign_code}
                </Link>
              </TableCell>
              <TableCell>{campaign.use_case}</TableCell>
              <TableCell>{campaign.vertical}</TableCell>
              <TableCell>{campaign.campaign_status}</TableCell>
              <TableCell align="right">{campaign.no_of_numbers}/50</TableCell>
              <TableCell>{campaign.auto_renew ? 'Yes' : 'No'}</TableCell>
              <TableCell>{rezonedDate}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  return (
    <>
      <Typography variant="h2" gutterBottom sx={{ paddingTop: 2 }}>
        Campaigns
      </Typography>
      <TableContainer
        sx={{
          marginBottom: 4,
          overflowX: 'auto',
          width: '100%',
          whiteSpace: 'nowrap',
        }}
      >
        <Table id="inbox">
          <TableHead>
            <TableRow>
              <TableCell>{formattedMessages.campaignNameTable}</TableCell>
              <TableCell>{formattedMessages.campaignTypeTable}</TableCell>
              <TableCell>{formattedMessages.verticalTable}</TableCell>
              <TableCell>{formattedMessages.statusTable}</TableCell>
              <TableCell align="right">
                {formattedMessages.activeNumbersTable}
              </TableCell>
              <TableCell>{formattedMessages.autoRenewalTable}</TableCell>
              <TableCell>
                {formattedMessages.nextRenewalExpirationDate}
              </TableCell>
            </TableRow>
          </TableHead>
          {generateCampaignTable()}
        </Table>
      </TableContainer>
    </>
  );
};
export default CampaignsTable;
